import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { sendStyles } from '@asphalt-react/context';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Avatar__2Wmr_ {\n  --avatar-background-color: var(\n    --background-fill-inverse,\n    hsla(219, 42%, 24%, 1)\n  );\n\n  --avatar-xxs-size: 1.5rem;\n  --avatar-xs-size: 2rem;\n  --avatar-s-size: 2.5rem;\n  --avatar-m-size: 3rem;\n  --avatar-l-size: 3.5rem;\n\n  --avatar-xxs-text: var(--label-2xs, 0.63rem);\n  --avatar-xs-text: var(--label-xs, 0.75rem);\n  --avatar-s-text: var(--label-s, 0.88rem);\n  --avatar-m-text: var(--label-m, 1rem);\n  --avatar-l-text: var(--label-l, 1.13rem);\n\n  --avatar-xxs-svg: 0.625rem;\n  --avatar-xs-svg: 0.75rem;\n  --avatar-s-svg: 1rem;\n  --avatar-m-svg: 1.25rem;\n  --avatar-l-svg: 1.5rem;\n\n  --avatar-svg-fill: var(--icon-inverse, hsla(0, 0%, 100%, 1));\n\n  --avatar-text-color: var(--text-inverse, hsla(0, 0%, 100%, 1));\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--avatar-background-color);\n  color: var(--avatar-text-color);\n  text-transform: uppercase;\n  -webkit-clip-path: circle(49% at 50% 50%);\n          clip-path: circle(49% at 50% 50%);\n}\n\n.Avatar__2Wmr_ img {\n  width: 100%;\n}\n\n.xxs__1SEH7 {\n  width: var(--avatar-xxs-size);\n  height: var(--avatar-xxs-size);\n  font-size: var(--avatar-xxs-text);\n}\n\n.xs__2-HYu {\n  width: var(--avatar-xs-size);\n  height: var(--avatar-xs-size);\n  font-size: var(--avatar-xs-text);\n}\n\n.s__12lCC {\n  width: var(--avatar-s-size);\n  height: var(--avatar-s-size);\n  font-size: var(--avatar-s-text);\n}\n\n.m__18NZs {\n  width: var(--avatar-m-size);\n  height: var(--avatar-m-size);\n  font-size: var(--avatar-m-text);\n}\n\n.l__3dYfT {\n  width: var(--avatar-l-size);\n  height: var(--avatar-l-size);\n  font-size: var(--avatar-l-text);\n}\n";
var styles = {"Avatar":"Avatar__2Wmr_","xxs":"xxs__1SEH7","xs":"xs__2-HYu","s":"s__12lCC","m":"m__18NZs","l":"l__3dYfT"};
var stylesheet=".Avatar__2Wmr_ {\n  --avatar-background-color: var(\n    --background-fill-inverse,\n    hsla(219, 42%, 24%, 1)\n  );\n\n  --avatar-xxs-size: 1.5rem;\n  --avatar-xs-size: 2rem;\n  --avatar-s-size: 2.5rem;\n  --avatar-m-size: 3rem;\n  --avatar-l-size: 3.5rem;\n\n  --avatar-xxs-text: var(--label-2xs, 0.63rem);\n  --avatar-xs-text: var(--label-xs, 0.75rem);\n  --avatar-s-text: var(--label-s, 0.88rem);\n  --avatar-m-text: var(--label-m, 1rem);\n  --avatar-l-text: var(--label-l, 1.13rem);\n\n  --avatar-xxs-svg: 0.625rem;\n  --avatar-xs-svg: 0.75rem;\n  --avatar-s-svg: 1rem;\n  --avatar-m-svg: 1.25rem;\n  --avatar-l-svg: 1.5rem;\n\n  --avatar-svg-fill: var(--icon-inverse, hsla(0, 0%, 100%, 1));\n\n  --avatar-text-color: var(--text-inverse, hsla(0, 0%, 100%, 1));\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--avatar-background-color);\n  color: var(--avatar-text-color);\n  text-transform: uppercase;\n  -webkit-clip-path: circle(49% at 50% 50%);\n          clip-path: circle(49% at 50% 50%);\n}\n\n.Avatar__2Wmr_ img {\n  width: 100%;\n}\n\n.xxs__1SEH7 {\n  width: var(--avatar-xxs-size);\n  height: var(--avatar-xxs-size);\n  font-size: var(--avatar-xxs-text);\n}\n\n.xs__2-HYu {\n  width: var(--avatar-xs-size);\n  height: var(--avatar-xs-size);\n  font-size: var(--avatar-xs-text);\n}\n\n.s__12lCC {\n  width: var(--avatar-s-size);\n  height: var(--avatar-s-size);\n  font-size: var(--avatar-s-text);\n}\n\n.m__18NZs {\n  width: var(--avatar-m-size);\n  height: var(--avatar-m-size);\n  font-size: var(--avatar-m-text);\n}\n\n.l__3dYfT {\n  width: var(--avatar-l-size);\n  height: var(--avatar-l-size);\n  font-size: var(--avatar-l-text);\n}\n";
styleInject(css_248z);

/**
 * maximum string length for Initials Avatar
 */
const strLength = 3;

/**
 * Return the element's type
 *
 * @param {object} children
 * @returns {string}
 */

const getType = children => {
  if ( /*#__PURE__*/isValidElement(children)) {
    if (!children.props.mdxType) {
      if (typeof children.type === "function") {
        return children.type().type;
      }

      return children.type;
    }

    if (typeof children.props.originalType === "function") {
      return children.props.originalType().type;
    }

    return children.props.originalType;
  }

  return typeof children;
};
const sizeClass = size => {
  const sizes = ["xxs", "xs", "s", "m", "l"];

  if (sizes.includes(size)) {
    return size;
  }

  return "m";
};

const Avatar = ({
  children,
  size,
  ...props
}) => {
  //Send styles to server
  sendStyles(stylesheet); // filtering out style and className

  /* eslint-disable-next-line react/prop-types */

  const {
    style,
    className,
    ...rest
  } = props;
  let avatarClasses = cn(styles.Avatar, styles[sizeClass(size)]);
  const type = getType(children);

  if (type === "string") {
    children = children.trim();

    if (children.length > strLength) {
      children = children.substr(0, strLength);
      console.warn(`String length cannot be greater than ${strLength} characters. Using first ${strLength} characters`);
    }

    avatarClasses = cn(styles.Avatar, styles.text, styles[sizeClass(size)]);
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: avatarClasses
  }, rest), children);
};
Avatar.propTypes = {
  /**
   * Image or letters to display
   */
  children: PropTypes.node.isRequired,

  /**
   * Renders the Avatar with the provided size. accepts xxs, xs, s, m, l sizes.
   */
  size: PropTypes.oneOf(["xxs", "xs", "s", "m", "l"])
};
Avatar.defaultProps = {
  size: "m"
};

export default Avatar;
